React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
OrganizationMembersItemComponent = require 'views/organization/organization-members-item-component'
_ = require 'underscore'

module.exports = class OrganizationMembersListComponent extends React.Component

  render: t.renderable ->
    { memberItems,
      memberTypeFilter
    } = @props

    if !memberItems.length
      t.div ->
        t.div '.org-members-missing-container', ->
          t.img
            className: 'org-members-missing-illustration'
            alt: t.l 'no-guest-result'
            src: require('images/organization/missing.svg')
          t.div '.org-members-missing-content', ->
            if memberTypeFilter is 'guest'
              t.p -> t.format 'no-guest-result'
            else
              t.p -> t.format 'no-member-result'
    else
      t.div '.org-members-list', ->
          for member in memberItems
            t.addElement React.createElement OrganizationMembersItemComponent, member




// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-list-component.coffee